// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.profileDetails {
  padding: 20px;
  padding-bottom: 0;
}
.profileDetails .personalDetail {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px;
}
.profileDetails .personalDetail .img_container {
  width: 70px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
}
.profileDetails .personalDetail .img_container img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.profileDetails .personalDetail .img_container:hover {
  transform: translateY(-2px);
}
.profileDetails .personalDetail .fingerDetails {
  width: 100%;
}
.profileDetails .personalDetail .fingerDetails .form-group {
  width: 70%;
  margin-bottom: 0;
}
.profileDetails .personalDetail .fingerDetails .form-group input {
  height: 30px;
  font-size: 13px;
  font-weight: 600;
  color: #3d3c3c;
  margin-bottom: 10px;
}
.profileDetails .personalDetail .fingerDetails .form-group select {
  height: 40px;
  font-size: 13px;
  padding: 0.6rem 0.75rem;
  font-weight: 600;
  color: #3d3c3c;
  margin-bottom: 10px;
}
.profileDetails .personalDetail .fingerDetails p {
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
}
.profileDetails .personalDetail .fingerDetails p span {
  font-weight: 600;
  color: #3d3c3c;
}
.profileDetails .personalDetail .fingerDetails .name {
  margin-bottom: 6px;
  display: flex;
  align-items: center;
}
.profileDetails .personalDetail .fingerDetails .name i {
  font-size: 15px;
  color: rgb(0, 209, 0);
  cursor: pointer;
}

.report h3 {
  background-color: #f78400;
}
.report .card-body {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.report .card-body .img_container {
  width: 100%;
  height: 100%;
  max-width: 1200px;
  overflow: hidden;
}
.report .card-body .img_container img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.report .card-body .pdf {
  max-width: 990px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
}
.report .card-body .pageToCapture {
  position: relative;
}
.report .card-body .img-fluid {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.report .card-body .btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.report .card-body .absolute {
  position: absolute;
  color: #ffffff;
  font-weight: 600;
  font-size: 12px;
  z-index: 2;
}
.report .card-body .l1 {
  left: 17%;
  top: 49%;
  z-index: 2;
}
.report .card-body .l2 {
  left: 65%;
  top: 49%;
  z-index: 2;
}
.report .card-body .l3 {
  left: 39%;
  top: 55%;
  z-index: 2;
}
.report .card-body .l4 {
  left: 74%;
  top: 55%;
  z-index: 2;
}
.report .card-body .l5 {
  left: 23.5%;
  top: 61%;
  z-index: 2;
}
.report .card-body .l6 {
  left: 73%;
  top: 61%;
  z-index: 2;
}
.report .card-body .l151 {
  left: 33%;
  top: 69.5%;
  z-index: 2;
}
.report .card-body .l7 {
  left: 12.5%;
  top: 39.5%;
  z-index: 2;
  color: #000;
}
.report .card-body .l8 {
  right: 3.5%;
  color: black;
  top: 39.5%;
}
.report .card-body .l9 {
  right: 44%;
  top: 46.2%;
}
.report .card-body .l10 {
  left: 42%;
  top: 64.5%;
  color: white;
}
.report .card-body .l11 {
  right: 40.5%;
  top: 64.5%;
}
.report .card-body .l12 {
  left: 48.7%;
  top: 33%;
}
.report .card-body .l13 {
  left: 32%;
  top: 51.5%;
}
.report .card-body .l14 {
  right: 33%;
  top: 51.5%;
}
.report .card-body .l15 {
  left: 49.2%;
  top: 35%;
}
.report .card-body .l16 {
  left: 23.5%;
  top: 53%;
}
.report .card-body .l17 {
  left: 49%;
  top: 52%;
}
.report .card-body .l18 {
  right: 23%;
  top: 53.5%;
}
.report .card-body .l19 {
  left: 49%;
  top: 57%;
}
.report .card-body .l20 {
  left: 49%;
  top: 34.7%;
}
.report .card-body .l21 {
  left: 23.5%;
  top: 52.5%;
}
.report .card-body .l22 {
  right: 22.5%;
  top: 51%;
}
.report .card-body .l23 {
  left: 49%;
  top: 34.5%;
}
.report .card-body .l24 {
  left: 34%;
  top: 52.5%;
}
.report .card-body .l25 {
  right: 34%;
  top: 51%;
}
.report .card-body .l26 {
  left: 49%;
  top: 34.5%;
}
.report .card-body .l27 {
  left: 34%;
  top: 51.5%;
}
.report .card-body .l28 {
  right: 34%;
  top: 53%;
}
.report .card-body .l29 {
  left: 49%;
  top: 34%;
}
.report .card-body .l30 {
  left: 49%;
  top: 52%;
}
.report .card-body .l31 {
  left: 34.3%;
  top: 53.5%;
}
.report .card-body .l32 {
  right: 30%;
  top: 26.5%;
}
.report .card-body .l33 {
  right: 30%;
  top: 31.5%;
}
.report .card-body .l34 {
  right: 30%;
  top: 36.2%;
}
.report .card-body .l35 {
  right: 30%;
  top: 40.9%;
}
.report .card-body .l36 {
  right: 30%;
  top: 45.7%;
}
.report .card-body .l37 {
  left: 44%;
  top: 20%;
}
.report .card-body .l38 {
  right: 32%;
  top: 20%;
}
.report .card-body .l39 {
  left: 44%;
  top: 54.5%;
}
.report .card-body .l40 {
  right: 33%;
  top: 54.5%;
}
.report .card-body .l41 {
  left: 41%;
  bottom: 46%;
}
.report .card-body .l42 {
  right: 19%;
  bottom: 46%;
}
.report .card-body .l43 {
  left: 41%;
  bottom: 24.5%;
}
.report .card-body .l44 {
  right: 18.8%;
  bottom: 24.3%;
}
.report .card-body .l45 {
  left: 27.5%;
  bottom: 23.6%;
}
.report .card-body .l46 {
  left: 24.5%;
  bottom: 25.5%;
}
.report .card-body .l47 {
  left: 29.5%;
  bottom: 23.6%;
}
.report .card-body .l48 {
  left: 36%;
  top: 27.5%;
  color: #000;
}
.report .card-body .l49 {
  right: 34%;
  top: 27.5%;
}
.report .card-body .l50 {
  right: 41%;
  top: 36%;
}
.report .card-body .l51 {
  right: 15%;
  top: 36%;
}
.report .card-body .l52 {
  right: 39%;
  top: 52.5%;
}
.report .card-body .l53 {
  right: 16%;
  top: 52.5%;
}
.report .card-body .l54 {
  right: 39%;
  top: 69.5%;
}
.report .card-body .l55 {
  right: 16%;
  top: 69.5%;
}
.report .card-body .l56 {
  left: 38%;
  top: 23%;
  font-weight: 700;
  color: #000;
}
.report .card-body .l57 {
  right: 19%;
  top: 23%;
  font-weight: 700;
  color: #000;
}
.report .card-body .l58 {
  left: 38.7%;
  bottom: 34.5%;
  font-weight: 700;
  color: #000;
  font-size: 15px;
}
.report .card-body .l59 {
  right: 20.2%;
  bottom: 33%;
}
.report .card-body .l60 {
  left: 21%;
  top: 29.8%;
}
.report .card-body .l61 {
  right: 43%;
  top: 29.8%;
}
.report .card-body .l62 {
  right: 16%;
  top: 29.8%;
}
.report .card-body .l63 {
  left: 33.5%;
  top: 28.5%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l64 {
  right: 14%;
  top: 28.5%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l65 {
  left: 33.5%;
  top: 36%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l66 {
  right: 14%;
  top: 36%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l67 {
  left: 33.5%;
  top: 43.4%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l68 {
  right: 14%;
  top: 43.4%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l69 {
  left: 33.5%;
  top: 51%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l70 {
  right: 14%;
  top: 51%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l71 {
  left: 33.5%;
  bottom: 27.8%;
  font-size: 20px;
}
.report .card-body .l72 {
  right: 14%;
  bottom: 27.8%;
  font-size: 20px;
}
.report .card-body .l73 {
  left: 33.5%;
  bottom: 20.7%;
  font-size: 20px;
}
.report .card-body .l74 {
  right: 14%;
  bottom: 20.7%;
  font-size: 20px;
}
.report .card-body .l75 {
  left: 33.5%;
  bottom: 13%;
  font-size: 20px;
}
.report .card-body .l76 {
  right: 14%;
  bottom: 13%;
  font-size: 20px;
}
.report .card-body .l77 {
  left: 33.5%;
  bottom: 5%;
  font-size: 20px;
}
.report .card-body .l78 {
  right: 14%;
  bottom: 5%;
  font-size: 20px;
}
.report .card-body .l79 {
  left: 33.5%;
  top: 59%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l80 {
  right: 14%;
  top: 59%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l81 {
  left: 33.5%;
  top: 30.5%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l82 {
  right: 14%;
  top: 30.5%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l83 {
  left: 33.5%;
  top: 38%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l84 {
  right: 14%;
  top: 38%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l85 {
  left: 33.5%;
  bottom: 41%;
  font-size: 20px;
}
.report .card-body .l86 {
  right: 14%;
  bottom: 41%;
  font-size: 20px;
}
.report .card-body .l87 {
  left: 33.5%;
  bottom: 33.4%;
  font-size: 20px;
}
.report .card-body .l88 {
  right: 14%;
  bottom: 33.4%;
  font-size: 20px;
}
.report .card-body .l89 {
  left: 33.5%;
  bottom: 25.8%;
  font-size: 20px;
}
.report .card-body .l90 {
  right: 14%;
  bottom: 25.8%;
  font-size: 20px;
}
.report .card-body .l91 {
  left: 33.5%;
  bottom: 18%;
  font-size: 20px;
}
.report .card-body .l92 {
  right: 14%;
  bottom: 18%;
  font-size: 20px;
}
.report .card-body .l93 {
  left: 33.5%;
  bottom: 10.5%;
  font-size: 20px;
}
.report .card-body .l94 {
  right: 14%;
  bottom: 10.5%;
  font-size: 20px;
}
.report .card-body .l95 {
  left: 33.5%;
  top: 45.5%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l96 {
  right: 14%;
  top: 45.5%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l97 {
  left: 33.5%;
  bottom: 32%;
  font-size: 20px;
}
.report .card-body .l98 {
  right: 14%;
  bottom: 32%;
  font-size: 20px;
}
.report .card-body .l99 {
  left: 33.5%;
  bottom: 24.5%;
  font-size: 20px;
}
.report .card-body .l100 {
  right: 14%;
  bottom: 24.5%;
  font-size: 20px;
}
.report .card-body .l101 {
  left: 33.5%;
  bottom: 17%;
  font-size: 20px;
}
.report .card-body .l102 {
  right: 14%;
  bottom: 17%;
  font-size: 20px;
}
.report .card-body .l103 {
  left: 33.5%;
  bottom: 9.5%;
  font-size: 20px;
}
.report .card-body .l104 {
  right: 14%;
  bottom: 9.5%;
  font-size: 20px;
}
.report .card-body .l105 {
  left: 33.5%;
  top: 44%;
  font-size: 20px;
}
.report .card-body .l106 {
  right: 14%;
  top: 44%;
  font-size: 20px;
}
.report .card-body .l107 {
  left: 33.5%;
  bottom: 37%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l108 {
  right: 14%;
  bottom: 37%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l109 {
  left: 33.5%;
  bottom: 29.5%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l110 {
  right: 14%;
  bottom: 29.5%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l111 {
  left: 33.5%;
  bottom: 22%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l112 {
  right: 14%;
  bottom: 22%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l113 {
  left: 33.5%;
  bottom: 14.3%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l114 {
  right: 14%;
  bottom: 14.3%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l115 {
  left: 33.5%;
  bottom: 6.5%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l116 {
  right: 14%;
  bottom: 6.5%;
  font-weight: 700;
  color: #000;
  font-size: 20px;
}
.report .card-body .l117 {
  left: 33.5%;
  top: 28.5%;
  font-size: 20px;
}
.report .card-body .l118 {
  right: 14%;
  top: 28.5%;
  font-size: 20px;
}
.report .card-body .l119 {
  left: 33.5%;
  top: 36%;
  font-size: 20px;
}
.report .card-body .l120 {
  right: 14%;
  top: 36%;
  font-size: 20px;
}
.report .card-body .l121 {
  left: 34%;
  top: 37.8%;
}
.report .card-body .l122 {
  right: 35%;
  top: 38%;
}
.report .card-body .l123 {
  left: 34%;
  top: 45.3%;
}
.report .card-body .l124 {
  right: 35%;
  top: 45%;
}
.report .card-body .l125 {
  left: 34%;
  top: 53%;
}
.report .card-body .l126 {
  right: 35%;
  top: 53%;
}
.report .card-body .l127 {
  left: 34%;
  top: 60.8%;
}
.report .card-body .l128 {
  right: 35%;
  top: 60.8%;
}
.report .card-body .l129 {
  left: 17%;
  top: 75.5%;
}
.report .card-body .l130 {
  right: 60%;
  top: 75.5%;
}
.report .card-body .l131 {
  right: 32%;
  top: 75.5%;
}
.report .card-body .l132 {
  right: 19.5%;
  top: 75.5%;
}
.report .card-body .l133 {
  right: 61.5%;
  top: 41%;
}
.report .card-body .l134 {
  right: 61.5%;
  top: 48%;
}
.report .card-body .l135 {
  right: 61.5%;
  top: 56%;
}
.report .card-body .l136 {
  right: 80%;
  top: 71%;
}
.report .card-body .l137 {
  right: 54%;
  top: 71%;
}
.report .card-body .l138 {
  right: 35.5%;
  top: 71%;
}
.report .card-body .l139 {
  right: 18.5%;
  top: 71%;
}
.report .card-body .l140 {
  right: 4.5%;
  top: 71%;
}
.report .card-body .l141 {
  right: 82%;
  top: 78.8%;
}
.report .card-body .l142 {
  right: 55%;
  top: 78.8%;
}
.report .card-body .l143 {
  right: 82%;
  top: 87%;
}
.report .card-body .l144 {
  right: 71%;
  top: 87%;
}
.report .card-body .l145 {
  right: 71%;
  top: 87%;
}
.report .card-body .l146 {
  right: 34.5%;
  top: 78.8%;
}
.report .card-body .l147 {
  right: 6.5%;
  top: 78.8%;
}
.report .card-body .l148 {
  right: 34.5%;
  top: 87%;
}
.report .card-body .l149 {
  right: 22.7%;
  top: 87%;
}
.report .card-body .l150 {
  right: 6.5%;
  top: 87%;
}
.report .card-body .c1 {
  right: 30px;
  bottom: 50px;
}
.report .card-body .c2 {
  left: 30px;
  bottom: 50px;
}
.report .card-body .c3 {
  left: 50%;
  transform: translateX(-50%);
  top: 20%;
}
.report .card-body .c4 {
  right: 15%;
  top: 38%;
}
.report .card-body .c5 {
  left: 50%;
  transform: translateX(-50%);
  top: 30%;
}
.report .card-body .c6 {
  left: 50%;
  transform: translateX(-50%);
  bottom: 30px;
}
.report .card-body .pie-chart {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: conic-gradient(#2e9db8 0% 25%, #dc1c28 25% 60%, #e9601a 60% 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.report .card-body .segment {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 10px;
}
.report .card-body .percentage {
  font-size: 24px;
  font-weight: bold;
  color: #fff;
}
.report .card-body .label {
  font-size: 16px;
  color: #333;
}

.card .table td {
  font-size: 13px;
  padding: 5px 10px;
}

table.personlDetails-table {
  border: 1px solid #1d52ff;
  width: 100%;
}
table.personlDetails-table th {
  background-color: #1d52ff;
  padding: 6px 10px;
  color: #ffffff;
}
table.personlDetails-table td {
  padding: 6px 10px;
  font-size: 13px;
  border: 1px dotted #ccc;
}

.update-btn .spinner-border {
  width: 1rem;
  height: 1rem;
}

.ant-pagination-next .anticon,
.ant-pagination-prev .anticon {
  color: #003bfe;
}

.status-btn {
  width: 103px;
}

.jsontoxlsx .ant-modal-content {
  background-color: #fff;
}
.jsontoxlsx .ant-modal-title {
  background-color: #fff;
}

#upload-student-list {
  display: none;
}

.upload-student-list-label {
  border: 1px dashed #cccccc;
  padding: 20px;
  background-color: #f7fdff;
  border-radius: 8px;
  display: block;
}
.upload-student-list-label p {
  margin-bottom: 0px;
  text-align: center;
  font-weight: 400;
}

.login-wrapper {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  font-family: "Poppins", sans-serif;
}

.login-card {
  display: flex;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  width: 900px;
  max-width: 95%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.login-left {
  flex: 1 1;
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: #fff;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom-input {
  border-radius: 50px;
  padding-right: 2.5rem;
}

.custom-input:focus {
  box-shadow: none;
}

.form-group .fa-eye,
.form-group .fa-eye-slash {
  transition: color 0.2s ease;
}

.form-group .fa-eye:hover,
.form-group .fa-eye-slash:hover {
  color: #0d6efd;
  /* Bootstrap primary blue on hover */
}

.login-illustration {
  width: 80%;
  max-width: 300px;
  margin-bottom: 20px;
}

.login-info-text {
  text-align: center;
  font-size: 14px;
  opacity: 0.9;
}

.login-right {
  flex: 1 1;
  padding: 50px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-badge {
  display: inline-block;
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  color: #fff;
  border-radius: 0 20px 20px 0;
  /* no rounding on left, rounded on right */
  padding: 6px 20px;
  font-size: 14px;
  font-weight: 500;
  position: absolute;
  /* or relative depending on your layout */
  top: -20px;
  /* adjust as needed */
  left: -80px;
  /* aligns to left side */
}

.custom-input {
  border: none;
  border-bottom: 2px solid #ccc !important;
  border-radius: 0;
  padding: 10px 5px;
  box-shadow: none;
  transition: all 0.3s ease;
}

.custom-input:focus {
  border-bottom: 2px solid #6a11cb;
  box-shadow: none;
  background-color: #fff !important;
}

.eye-icon {
  cursor: pointer;
  border-bottom: 2px solid #ccc !important;
}

.login-btn {
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%) !important;
  border: none;
  font-weight: 500;
}

.login-btn:hover {
  opacity: 0.9;
}

@media (max-width: 768px) {
  .login-card {
    flex-direction: column;
  }
  .login-left,
  .login-right {
    width: 100%;
    padding: 30px;
  }
  .login-illustration {
    max-width: 200px;
  }
}
@media (max-width: 768px) {
  .login-card {
    flex-direction: column;
  }
  .login-left,
  .login-right {
    width: 100%;
    padding: 30px;
  }
  .login-illustration {
    max-width: 200px;
  }
}
/* ✅ Responsive header layout */
@media (max-width: 768px) {
  .card-header.d-flex {
    flex-direction: column !important;
    align-items: flex-start !important;
  }
  .card-header .d-flex.align-items-center {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
  .xlsxDownloadBtn {
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;
    background-color: #0d6efd !important;
  }
  .search-container {
    display: flex;
    width: 100%;
  }
  .search-container input {
    flex: 1 1;
  }
  .search-container .search_btn {
    margin-left: 5px;
    width: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
/* ✅ Card layout for small screens */
@media (max-width: 768px) {
  .mobile-card-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1rem;
    gap: 1rem;
  }
}
/* ✅ Tablet view - 2 cards per row */
@media (min-width: 769px) and (max-width: 1024px) {
  .mobile-card-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
    gap: 1rem;
  }
}
.navLink.active {
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 8px;
}

.navLink {
  padding: 12px 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none !important;
  font-size: 15px;
}

.navLink.active {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  font-weight: 600;
}

.ant-message {
  right: auto !important;
  left: 525px !important;
  top: 20px !important;
  transform: none !important;
}

.select-box select {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 14px;
  outline: none;
  background-color: #0d6efd;
  color: #fff;
  border: none;
  margin-right: 1300px;
  display: inline-flex;
  align-items: center;
}

.option-layout {
  background-color: #fff !important;
  color: #000 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;EAEE,wBAAA;EACA,SAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,aAAA;EAEA,iBAAA;AACF;AACE;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AACJ;AACI;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AACN;AACM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AACR;AAEM;EACE,2BAAA;AAAR;AAII;EACE,WAAA;AAFN;AAIM;EACE,UAAA;EACA,gBAAA;AAFR;AAIQ;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAFV;AAKQ;EACE,YAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAHV;AAOM;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AALR;AAOQ;EACE,gBAAA;EACA,cAAA;AALV;AASM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAPR;AASQ;EACE,eAAA;EACA,qBAAA;EACA,eAAA;AAPV;;AAeE;EACE,yBAAA;AAZJ;AAeE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;AAbJ;AAeI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAbN;AAeM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAbR;AAiBI;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAfN;AAkBI;EACE,kBAAA;AAhBN;AAmBI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAjBN;AAoBI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAlBN;AAqBI;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;AAnBN;AAsBI;EACE,SAAA;EACA,QAAA;EACA,UAAA;AApBN;AAuBI;EACE,SAAA;EACA,QAAA;EACA,UAAA;AArBN;AAwBI;EACE,SAAA;EACA,QAAA;EACA,UAAA;AAtBN;AAyBI;EACE,SAAA;EACA,QAAA;EACA,UAAA;AAvBN;AA0BI;EACE,WAAA;EACA,QAAA;EACA,UAAA;AAxBN;AA2BI;EACE,SAAA;EACA,QAAA;EACA,UAAA;AAzBN;AA4BI;EACE,SAAA;EACA,UAAA;EACA,UAAA;AA1BN;AA6BI;EACE,WAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AA3BN;AA8BI;EACE,WAAA;EACA,YAAA;EACA,UAAA;AA5BN;AA+BI;EACE,UAAA;EACA,UAAA;AA7BN;AAgCI;EACE,SAAA;EACA,UAAA;EACA,YAAA;AA9BN;AAiCI;EACE,YAAA;EACA,UAAA;AA/BN;AAkCI;EACE,WAAA;EACA,QAAA;AAhCN;AAmCI;EACE,SAAA;EACA,UAAA;AAjCN;AAoCI;EACE,UAAA;EACA,UAAA;AAlCN;AAqCI;EACE,WAAA;EACA,QAAA;AAnCN;AAsCI;EACE,WAAA;EACA,QAAA;AApCN;AAuCI;EACE,SAAA;EACA,QAAA;AArCN;AAwCI;EACE,UAAA;EACA,UAAA;AAtCN;AAyCI;EACE,SAAA;EACA,QAAA;AAvCN;AA0CI;EACE,SAAA;EACA,UAAA;AAxCN;AA2CI;EACE,WAAA;EACA,UAAA;AAzCN;AA4CI;EACE,YAAA;EACA,QAAA;AA1CN;AA6CI;EACE,SAAA;EACA,UAAA;AA3CN;AA8CI;EACE,SAAA;EACA,UAAA;AA5CN;AA+CI;EACE,UAAA;EACA,QAAA;AA7CN;AAgDI;EACE,SAAA;EACA,UAAA;AA9CN;AAiDI;EACE,SAAA;EACA,UAAA;AA/CN;AAkDI;EACE,UAAA;EACA,QAAA;AAhDN;AAmDI;EACE,SAAA;EACA,QAAA;AAjDN;AAoDI;EACE,SAAA;EACA,QAAA;AAlDN;AAqDI;EACE,WAAA;EACA,UAAA;AAnDN;AAsDI;EACE,UAAA;EACA,UAAA;AApDN;AAuDI;EACE,UAAA;EACA,UAAA;AArDN;AAwDI;EACE,UAAA;EACA,UAAA;AAtDN;AAyDI;EACE,UAAA;EACA,UAAA;AAvDN;AA0DI;EACE,UAAA;EACA,UAAA;AAxDN;AA2DI;EACE,SAAA;EACA,QAAA;AAzDN;AA4DI;EACE,UAAA;EACA,QAAA;AA1DN;AA6DI;EACE,SAAA;EACA,UAAA;AA3DN;AA8DI;EACE,UAAA;EACA,UAAA;AA5DN;AA+DI;EACE,SAAA;EACA,WAAA;AA7DN;AAgEI;EACE,UAAA;EACA,WAAA;AA9DN;AAiEI;EACE,SAAA;EACA,aAAA;AA/DN;AAkEI;EACE,YAAA;EACA,aAAA;AAhEN;AAmEI;EACE,WAAA;EACA,aAAA;AAjEN;AAoEI;EACE,WAAA;EACA,aAAA;AAlEN;AAqEI;EACE,WAAA;EACA,aAAA;AAnEN;AAsEI;EACE,SAAA;EACA,UAAA;EACA,WAAA;AApEN;AAuEI;EACE,UAAA;EACA,UAAA;AArEN;AAwEI;EACE,UAAA;EACA,QAAA;AAtEN;AAyEI;EACE,UAAA;EACA,QAAA;AAvEN;AA0EI;EACE,UAAA;EACA,UAAA;AAxEN;AA2EI;EACE,UAAA;EACA,UAAA;AAzEN;AA4EI;EACE,UAAA;EACA,UAAA;AA1EN;AA6EI;EACE,UAAA;EACA,UAAA;AA3EN;AA8EI;EACE,SAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;AA5EN;AA+EI;EACE,UAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;AA7EN;AAgFI;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AA9EN;AAiFI;EACE,YAAA;EACA,WAAA;AA/EN;AAkFI;EACE,SAAA;EACA,UAAA;AAhFN;AAmFI;EACE,UAAA;EACA,UAAA;AAjFN;AAoFI;EACE,UAAA;EACA,UAAA;AAlFN;AAqFI;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAnFN;AAsFI;EACE,UAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AApFN;AAuFI;EACE,WAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AArFN;AAwFI;EACE,UAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAtFN;AAyFI;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAvFN;AA0FI;EACE,UAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAxFN;AA2FI;EACE,WAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAzFN;AA4FI;EACE,UAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AA1FN;AA6FI;EACE,WAAA;EACA,aAAA;EACA,eAAA;AA3FN;AA8FI;EACE,UAAA;EACA,aAAA;EACA,eAAA;AA5FN;AA+FI;EACE,WAAA;EACA,aAAA;EACA,eAAA;AA7FN;AAgGI;EACE,UAAA;EACA,aAAA;EACA,eAAA;AA9FN;AAiGI;EACE,WAAA;EACA,WAAA;EACA,eAAA;AA/FN;AAkGI;EACE,UAAA;EACA,WAAA;EACA,eAAA;AAhGN;AAmGI;EACE,WAAA;EACA,UAAA;EACA,eAAA;AAjGN;AAoGI;EACE,UAAA;EACA,UAAA;EACA,eAAA;AAlGN;AAqGI;EACE,WAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAnGN;AAsGI;EACE,UAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AApGN;AAuGI;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AArGN;AAwGI;EACE,UAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAtGN;AAyGI;EACE,WAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAvGN;AA0GI;EACE,UAAA;EACA,QAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAxGN;AA2GI;EACE,WAAA;EACA,WAAA;EACA,eAAA;AAzGN;AA4GI;EACE,UAAA;EACA,WAAA;EACA,eAAA;AA1GN;AA6GI;EACE,WAAA;EACA,aAAA;EACA,eAAA;AA3GN;AA8GI;EACE,UAAA;EACA,aAAA;EACA,eAAA;AA5GN;AA+GI;EACE,WAAA;EACA,aAAA;EACA,eAAA;AA7GN;AAgHI;EACE,UAAA;EACA,aAAA;EACA,eAAA;AA9GN;AAiHI;EACE,WAAA;EACA,WAAA;EACA,eAAA;AA/GN;AAkHI;EACE,UAAA;EACA,WAAA;EACA,eAAA;AAhHN;AAmHI;EACE,WAAA;EACA,aAAA;EACA,eAAA;AAjHN;AAoHI;EACE,UAAA;EACA,aAAA;EACA,eAAA;AAlHN;AAqHI;EACE,WAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAnHN;AAsHI;EACE,UAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AApHN;AAuHI;EACE,WAAA;EACA,WAAA;EACA,eAAA;AArHN;AAwHI;EACE,UAAA;EACA,WAAA;EACA,eAAA;AAtHN;AAyHI;EACE,WAAA;EACA,aAAA;EACA,eAAA;AAvHN;AA0HI;EACE,UAAA;EACA,aAAA;EACA,eAAA;AAxHN;AA2HI;EACE,WAAA;EACA,WAAA;EACA,eAAA;AAzHN;AA4HI;EACE,UAAA;EACA,WAAA;EACA,eAAA;AA1HN;AA6HI;EACE,WAAA;EACA,YAAA;EACA,eAAA;AA3HN;AA8HI;EACE,UAAA;EACA,YAAA;EACA,eAAA;AA5HN;AA+HI;EACE,WAAA;EACA,QAAA;EACA,eAAA;AA7HN;AAgII;EACE,UAAA;EACA,QAAA;EACA,eAAA;AA9HN;AAiII;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AA/HN;AAkII;EACE,UAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAhIN;AAmII;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAjIN;AAoII;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAlIN;AAqII;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAnIN;AAsII;EACE,UAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AApIN;AAuII;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AArIN;AAwII;EACE,UAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAtIN;AAyII;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAvIN;AA0II;EACE,UAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AAxIN;AA2II;EACE,WAAA;EACA,UAAA;EACA,eAAA;AAzIN;AA4II;EACE,UAAA;EACA,UAAA;EACA,eAAA;AA1IN;AA6II;EACE,WAAA;EACA,QAAA;EACA,eAAA;AA3IN;AA8II;EACE,UAAA;EACA,QAAA;EACA,eAAA;AA5IN;AA+II;EACE,SAAA;EACA,UAAA;AA7IN;AAgJI;EACE,UAAA;EACA,QAAA;AA9IN;AAiJI;EACE,SAAA;EACA,UAAA;AA/IN;AAkJI;EACE,UAAA;EACA,QAAA;AAhJN;AAmJI;EACE,SAAA;EACA,QAAA;AAjJN;AAoJI;EACE,UAAA;EACA,QAAA;AAlJN;AAqJI;EACE,SAAA;EACA,UAAA;AAnJN;AAsJI;EACE,UAAA;EACA,UAAA;AApJN;AAuJI;EACE,SAAA;EACA,UAAA;AArJN;AAwJI;EACE,UAAA;EACA,UAAA;AAtJN;AAyJI;EACE,UAAA;EACA,UAAA;AAvJN;AA0JI;EACE,YAAA;EACA,UAAA;AAxJN;AA2JI;EACE,YAAA;EACA,QAAA;AAzJN;AA4JI;EACE,YAAA;EACA,QAAA;AA1JN;AA6JI;EACE,YAAA;EACA,QAAA;AA3JN;AA8JI;EACE,UAAA;EACA,QAAA;AA5JN;AA+JI;EACE,UAAA;EACA,QAAA;AA7JN;AAgKI;EACE,YAAA;EACA,QAAA;AA9JN;AAiKI;EACE,YAAA;EACA,QAAA;AA/JN;AAkKI;EACE,WAAA;EACA,QAAA;AAhKN;AAmKI;EACE,UAAA;EACA,UAAA;AAjKN;AAoKI;EACE,UAAA;EACA,UAAA;AAlKN;AAqKI;EACE,UAAA;EACA,QAAA;AAnKN;AAsKI;EACE,UAAA;EACA,QAAA;AApKN;AAuKI;EACE,UAAA;EACA,QAAA;AArKN;AAwKI;EACE,YAAA;EACA,UAAA;AAtKN;AAyKI;EACE,WAAA;EACA,UAAA;AAvKN;AA0KI;EACE,YAAA;EACA,QAAA;AAxKN;AA2KI;EACE,YAAA;EACA,QAAA;AAzKN;AA4KI;EACE,WAAA;EACA,QAAA;AA1KN;AA6KI;EACE,WAAA;EACA,YAAA;AA3KN;AA8KI;EACE,UAAA;EACA,YAAA;AA5KN;AA+KI;EACE,SAAA;EACA,2BAAA;EACA,QAAA;AA7KN;AAgLI;EACE,UAAA;EACA,QAAA;AA9KN;AAiLI;EACE,SAAA;EACA,2BAAA;EACA,QAAA;AA/KN;AAkLI;EACE,SAAA;EACA,2BAAA;EACA,YAAA;AAhLN;AAmLI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,6EAAA;EAGA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAnLN;AAsLI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AApLN;AAuLI;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AArLN;AAwLI;EACE,eAAA;EACA,WAAA;AAtLN;;AA2LA;EACE,eAAA;EACA,iBAAA;AAxLF;;AA2LA;EACE,yBAAA;EACA,WAAA;AAxLF;AA0LE;EACE,yBAAA;EACA,iBAAA;EACA,cAAA;AAxLJ;AA2LE;EACE,iBAAA;EACA,eAAA;EACA,uBAAA;AAzLJ;;AA8LE;EACE,WAAA;EACA,YAAA;AA3LJ;;AAiME;;EACE,cAAA;AA7LJ;;AAiMA;EACE,YAAA;AA9LF;;AAkME;EACE,sBAAA;AA/LJ;AAkME;EACE,sBAAA;AAhMJ;;AAoMA;EACE,aAAA;AAjMF;;AAoMA;EACE,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAjMF;AAmME;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;AAjMJ;;AAqMA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,kCAAA;AAlMF;;AAqMA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,0CAAA;AAlMF;;AAqMA;EACE,SAAA;EACA,6DAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAlMF;;AAqMA;EACE,mBAAA;EACA,qBAAA;AAlMF;;AAqMA;EACE,gBAAA;AAlMF;;AAqMA;;EAEE,2BAAA;AAlMF;;AAqMA;;EAEE,cAAA;EACA,oCAAA;AAlMF;;AAqMA;EACE,UAAA;EACA,gBAAA;EACA,mBAAA;AAlMF;;AAqMA;EACE,kBAAA;EACA,eAAA;EACA,YAAA;AAlMF;;AAqMA;EACE,SAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlMF;;AAqMA;EACE,qBAAA;EACA,6DAAA;EACA,WAAA;EACA,4BAAA;EACA,0CAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,UAAA;EACA,qBAAA;EACA,WAAA;EACA,wBAAA;AAlMF;;AAqMA;EACE,YAAA;EACA,wCAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;AAlMF;;AAqMA;EACE,gCAAA;EACA,gBAAA;EACA,iCAAA;AAlMF;;AAqMA;EACE,eAAA;EACA,wCAAA;AAlMF;;AAqMA;EACE,wEAAA;EACA,YAAA;EACA,gBAAA;AAlMF;;AAqMA;EACE,YAAA;AAlMF;;AAqMA;EACE;IACE,sBAAA;EAlMF;EAqMA;;IAEE,WAAA;IACA,aAAA;EAnMF;EAsMA;IACE,gBAAA;EApMF;AACF;AAuMA;EACE;IACE,sBAAA;EArMF;EAwMA;;IAEE,WAAA;IACA,aAAA;EAtMF;EAyMA;IACE,gBAAA;EAvMF;AACF;AA0MA,+BAAA;AACA;EACE;IACE,iCAAA;IACA,kCAAA;EAxMF;EA2MA;IACE,sBAAA;IACA,oBAAA;IACA,WAAA;EAzMF;EA4MA;IACE,WAAA;IACA,aAAA;IACA,mBAAA;IACA,oCAAA;EA1MF;EA6MA;IACE,aAAA;IACA,WAAA;EA3MF;EA8MA;IACE,SAAA;EA5MF;EA+MA;IACE,gBAAA;IACA,WAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EA7MF;AACF;AAgNA,oCAAA;AACA;EACE;IACE,aAAA;IACA,0BAAA;IACA,cAAA;IAAA,SAAA;EA9MF;AACF;AAiNA,oCAAA;AACA;EACE;IACE,aAAA;IACA,qCAAA;IACA,cAAA;IAAA,SAAA;EA/MF;AACF;AAsNA;EACE,2CAAA;EACA,kBAAA;AApNF;;AAuNA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;AApNF;;AAuNA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;AApNF;;AAuNA;EACE,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,0BAAA;AApNF;;AAwNE;EACE,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,oBAAA;EACA,mBAAA;AArNJ;;AAwNA;EACE,iCAAA;EACA,sBAAA;AArNF","sourcesContent":["input::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.profileDetails {\n  padding: 20px;\n\n  padding-bottom: 0;\n\n  .personalDetail {\n    display: flex;\n    justify-content: left;\n    align-items: center;\n    margin-bottom: 20px;\n    gap: 15px;\n\n    .img_container {\n      width: 70px;\n      height: 100px;\n      border-radius: 8px;\n      overflow: hidden;\n      cursor: pointer;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n      }\n\n      &:hover {\n        transform: translateY(-2px);\n      }\n    }\n\n    .fingerDetails {\n      width: 100%;\n\n      .form-group {\n        width: 70%;\n        margin-bottom: 0;\n\n        input {\n          height: 30px;\n          font-size: 13px;\n          font-weight: 600;\n          color: #3d3c3c;\n          margin-bottom: 10px;\n        }\n\n        select {\n          height: 40px;\n          font-size: 13px;\n          padding: 0.6rem 0.75rem;\n          font-weight: 600;\n          color: #3d3c3c;\n          margin-bottom: 10px;\n        }\n      }\n\n      p {\n        margin-bottom: 6px;\n        font-size: 13px;\n        font-weight: 500;\n\n        span {\n          font-weight: 600;\n          color: #3d3c3c;\n        }\n      }\n\n      .name {\n        margin-bottom: 6px;\n        display: flex;\n        align-items: center;\n\n        i {\n          font-size: 15px;\n          color: rgb(0, 209, 0);\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n\n.report {\n  h3 {\n    background-color: #f78400;\n  }\n\n  .card-body {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n\n    .img_container {\n      width: 100%;\n      height: 100%;\n      max-width: 1200px;\n      overflow: hidden;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n      }\n    }\n\n    .pdf {\n      max-width: 990px;\n      margin-left: auto;\n      margin-right: auto;\n      position: relative;\n    }\n\n    .pageToCapture {\n      position: relative;\n    }\n\n    .img-fluid {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    .btn-container {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .absolute {\n      position: absolute;\n      color: #ffffff;\n      font-weight: 600;\n      font-size: 12px;\n      z-index: 2;\n    }\n\n    .l1 {\n      left: 17%;\n      top: 49%;\n      z-index: 2;\n    }\n\n    .l2 {\n      left: 65%;\n      top: 49%;\n      z-index: 2;\n    }\n\n    .l3 {\n      left: 39%;\n      top: 55%;\n      z-index: 2;\n    }\n\n    .l4 {\n      left: 74%;\n      top: 55%;\n      z-index: 2;\n    }\n\n    .l5 {\n      left: 23.5%;\n      top: 61%;\n      z-index: 2;\n    }\n\n    .l6 {\n      left: 73%;\n      top: 61%;\n      z-index: 2;\n    }\n\n    .l151 {\n      left: 33%;\n      top: 69.5%;\n      z-index: 2;\n    }\n\n    .l7 {\n      left: 12.5%;\n      top: 39.5%;\n      z-index: 2;\n      color: #000;\n    }\n\n    .l8 {\n      right: 3.5%;\n      color: black;\n      top: 39.5%;\n    }\n\n    .l9 {\n      right: 44%;\n      top: 46.2%;\n    }\n\n    .l10 {\n      left: 42%;\n      top: 64.5%;\n      color: white;\n    }\n\n    .l11 {\n      right: 40.5%;\n      top: 64.5%;\n    }\n\n    .l12 {\n      left: 48.7%;\n      top: 33%;\n    }\n\n    .l13 {\n      left: 32%;\n      top: 51.5%;\n    }\n\n    .l14 {\n      right: 33%;\n      top: 51.5%;\n    }\n\n    .l15 {\n      left: 49.2%;\n      top: 35%;\n    }\n\n    .l16 {\n      left: 23.5%;\n      top: 53%;\n    }\n\n    .l17 {\n      left: 49%;\n      top: 52%;\n    }\n\n    .l18 {\n      right: 23%;\n      top: 53.5%;\n    }\n\n    .l19 {\n      left: 49%;\n      top: 57%;\n    }\n\n    .l20 {\n      left: 49%;\n      top: 34.7%;\n    }\n\n    .l21 {\n      left: 23.5%;\n      top: 52.5%;\n    }\n\n    .l22 {\n      right: 22.5%;\n      top: 51%;\n    }\n\n    .l23 {\n      left: 49%;\n      top: 34.5%;\n    }\n\n    .l24 {\n      left: 34%;\n      top: 52.5%;\n    }\n\n    .l25 {\n      right: 34%;\n      top: 51%;\n    }\n\n    .l26 {\n      left: 49%;\n      top: 34.5%;\n    }\n\n    .l27 {\n      left: 34%;\n      top: 51.5%;\n    }\n\n    .l28 {\n      right: 34%;\n      top: 53%;\n    }\n\n    .l29 {\n      left: 49%;\n      top: 34%;\n    }\n\n    .l30 {\n      left: 49%;\n      top: 52%;\n    }\n\n    .l31 {\n      left: 34.3%;\n      top: 53.5%;\n    }\n\n    .l32 {\n      right: 30%;\n      top: 26.5%;\n    }\n\n    .l33 {\n      right: 30%;\n      top: 31.5%;\n    }\n\n    .l34 {\n      right: 30%;\n      top: 36.2%;\n    }\n\n    .l35 {\n      right: 30%;\n      top: 40.9%;\n    }\n\n    .l36 {\n      right: 30%;\n      top: 45.7%;\n    }\n\n    .l37 {\n      left: 44%;\n      top: 20%;\n    }\n\n    .l38 {\n      right: 32%;\n      top: 20%;\n    }\n\n    .l39 {\n      left: 44%;\n      top: 54.5%;\n    }\n\n    .l40 {\n      right: 33%;\n      top: 54.5%;\n    }\n\n    .l41 {\n      left: 41%;\n      bottom: 46%;\n    }\n\n    .l42 {\n      right: 19%;\n      bottom: 46%;\n    }\n\n    .l43 {\n      left: 41%;\n      bottom: 24.5%;\n    }\n\n    .l44 {\n      right: 18.8%;\n      bottom: 24.3%;\n    }\n\n    .l45 {\n      left: 27.5%;\n      bottom: 23.6%;\n    }\n\n    .l46 {\n      left: 24.5%;\n      bottom: 25.5%;\n    }\n\n    .l47 {\n      left: 29.5%;\n      bottom: 23.6%;\n    }\n\n    .l48 {\n      left: 36%;\n      top: 27.5%;\n      color: #000;\n    }\n\n    .l49 {\n      right: 34%;\n      top: 27.5%;\n    }\n\n    .l50 {\n      right: 41%;\n      top: 36%;\n    }\n\n    .l51 {\n      right: 15%;\n      top: 36%;\n    }\n\n    .l52 {\n      right: 39%;\n      top: 52.5%;\n    }\n\n    .l53 {\n      right: 16%;\n      top: 52.5%;\n    }\n\n    .l54 {\n      right: 39%;\n      top: 69.5%;\n    }\n\n    .l55 {\n      right: 16%;\n      top: 69.5%;\n    }\n\n    .l56 {\n      left: 38%;\n      top: 23%;\n      font-weight: 700;\n      color: #000;\n    }\n\n    .l57 {\n      right: 19%;\n      top: 23%;\n      font-weight: 700;\n      color: #000;\n    }\n\n    .l58 {\n      left: 38.7%;\n      bottom: 34.5%;\n      font-weight: 700;\n      color: #000;\n      font-size: 15px;\n    }\n\n    .l59 {\n      right: 20.2%;\n      bottom: 33%;\n    }\n\n    .l60 {\n      left: 21%;\n      top: 29.8%;\n    }\n\n    .l61 {\n      right: 43%;\n      top: 29.8%;\n    }\n\n    .l62 {\n      right: 16%;\n      top: 29.8%;\n    }\n\n    .l63 {\n      left: 33.5%;\n      top: 28.5%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l64 {\n      right: 14%;\n      top: 28.5%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l65 {\n      left: 33.5%;\n      top: 36%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l66 {\n      right: 14%;\n      top: 36%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l67 {\n      left: 33.5%;\n      top: 43.4%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l68 {\n      right: 14%;\n      top: 43.4%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l69 {\n      left: 33.5%;\n      top: 51%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l70 {\n      right: 14%;\n      top: 51%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l71 {\n      left: 33.5%;\n      bottom: 27.8%;\n      font-size: 20px;\n    }\n\n    .l72 {\n      right: 14%;\n      bottom: 27.8%;\n      font-size: 20px;\n    }\n\n    .l73 {\n      left: 33.5%;\n      bottom: 20.7%;\n      font-size: 20px;\n    }\n\n    .l74 {\n      right: 14%;\n      bottom: 20.7%;\n      font-size: 20px;\n    }\n\n    .l75 {\n      left: 33.5%;\n      bottom: 13%;\n      font-size: 20px;\n    }\n\n    .l76 {\n      right: 14%;\n      bottom: 13%;\n      font-size: 20px;\n    }\n\n    .l77 {\n      left: 33.5%;\n      bottom: 5%;\n      font-size: 20px;\n    }\n\n    .l78 {\n      right: 14%;\n      bottom: 5%;\n      font-size: 20px;\n    }\n\n    .l79 {\n      left: 33.5%;\n      top: 59%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l80 {\n      right: 14%;\n      top: 59%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l81 {\n      left: 33.5%;\n      top: 30.5%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l82 {\n      right: 14%;\n      top: 30.5%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l83 {\n      left: 33.5%;\n      top: 38%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l84 {\n      right: 14%;\n      top: 38%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l85 {\n      left: 33.5%;\n      bottom: 41%;\n      font-size: 20px;\n    }\n\n    .l86 {\n      right: 14%;\n      bottom: 41%;\n      font-size: 20px;\n    }\n\n    .l87 {\n      left: 33.5%;\n      bottom: 33.4%;\n      font-size: 20px;\n    }\n\n    .l88 {\n      right: 14%;\n      bottom: 33.4%;\n      font-size: 20px;\n    }\n\n    .l89 {\n      left: 33.5%;\n      bottom: 25.8%;\n      font-size: 20px;\n    }\n\n    .l90 {\n      right: 14%;\n      bottom: 25.8%;\n      font-size: 20px;\n    }\n\n    .l91 {\n      left: 33.5%;\n      bottom: 18%;\n      font-size: 20px;\n    }\n\n    .l92 {\n      right: 14%;\n      bottom: 18%;\n      font-size: 20px;\n    }\n\n    .l93 {\n      left: 33.5%;\n      bottom: 10.5%;\n      font-size: 20px;\n    }\n\n    .l94 {\n      right: 14%;\n      bottom: 10.5%;\n      font-size: 20px;\n    }\n\n    .l95 {\n      left: 33.5%;\n      top: 45.5%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l96 {\n      right: 14%;\n      top: 45.5%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l97 {\n      left: 33.5%;\n      bottom: 32%;\n      font-size: 20px;\n    }\n\n    .l98 {\n      right: 14%;\n      bottom: 32%;\n      font-size: 20px;\n    }\n\n    .l99 {\n      left: 33.5%;\n      bottom: 24.5%;\n      font-size: 20px;\n    }\n\n    .l100 {\n      right: 14%;\n      bottom: 24.5%;\n      font-size: 20px;\n    }\n\n    .l101 {\n      left: 33.5%;\n      bottom: 17%;\n      font-size: 20px;\n    }\n\n    .l102 {\n      right: 14%;\n      bottom: 17%;\n      font-size: 20px;\n    }\n\n    .l103 {\n      left: 33.5%;\n      bottom: 9.5%;\n      font-size: 20px;\n    }\n\n    .l104 {\n      right: 14%;\n      bottom: 9.5%;\n      font-size: 20px;\n    }\n\n    .l105 {\n      left: 33.5%;\n      top: 44%;\n      font-size: 20px;\n    }\n\n    .l106 {\n      right: 14%;\n      top: 44%;\n      font-size: 20px;\n    }\n\n    .l107 {\n      left: 33.5%;\n      bottom: 37%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l108 {\n      right: 14%;\n      bottom: 37%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l109 {\n      left: 33.5%;\n      bottom: 29.5%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l110 {\n      right: 14%;\n      bottom: 29.5%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l111 {\n      left: 33.5%;\n      bottom: 22%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l112 {\n      right: 14%;\n      bottom: 22%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l113 {\n      left: 33.5%;\n      bottom: 14.3%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l114 {\n      right: 14%;\n      bottom: 14.3%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l115 {\n      left: 33.5%;\n      bottom: 6.5%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l116 {\n      right: 14%;\n      bottom: 6.5%;\n      font-weight: 700;\n      color: #000;\n      font-size: 20px;\n    }\n\n    .l117 {\n      left: 33.5%;\n      top: 28.5%;\n      font-size: 20px;\n    }\n\n    .l118 {\n      right: 14%;\n      top: 28.5%;\n      font-size: 20px;\n    }\n\n    .l119 {\n      left: 33.5%;\n      top: 36%;\n      font-size: 20px;\n    }\n\n    .l120 {\n      right: 14%;\n      top: 36%;\n      font-size: 20px;\n    }\n\n    .l121 {\n      left: 34%;\n      top: 37.8%;\n    }\n\n    .l122 {\n      right: 35%;\n      top: 38%;\n    }\n\n    .l123 {\n      left: 34%;\n      top: 45.3%;\n    }\n\n    .l124 {\n      right: 35%;\n      top: 45%;\n    }\n\n    .l125 {\n      left: 34%;\n      top: 53%;\n    }\n\n    .l126 {\n      right: 35%;\n      top: 53%;\n    }\n\n    .l127 {\n      left: 34%;\n      top: 60.8%;\n    }\n\n    .l128 {\n      right: 35%;\n      top: 60.8%;\n    }\n\n    .l129 {\n      left: 17%;\n      top: 75.5%;\n    }\n\n    .l130 {\n      right: 60%;\n      top: 75.5%;\n    }\n\n    .l131 {\n      right: 32%;\n      top: 75.5%;\n    }\n\n    .l132 {\n      right: 19.5%;\n      top: 75.5%;\n    }\n\n    .l133 {\n      right: 61.5%;\n      top: 41%;\n    }\n\n    .l134 {\n      right: 61.5%;\n      top: 48%;\n    }\n\n    .l135 {\n      right: 61.5%;\n      top: 56%;\n    }\n\n    .l136 {\n      right: 80%;\n      top: 71%;\n    }\n\n    .l137 {\n      right: 54%;\n      top: 71%;\n    }\n\n    .l138 {\n      right: 35.5%;\n      top: 71%;\n    }\n\n    .l139 {\n      right: 18.5%;\n      top: 71%;\n    }\n\n    .l140 {\n      right: 4.5%;\n      top: 71%;\n    }\n\n    .l141 {\n      right: 82%;\n      top: 78.8%;\n    }\n\n    .l142 {\n      right: 55%;\n      top: 78.8%;\n    }\n\n    .l143 {\n      right: 82%;\n      top: 87%;\n    }\n\n    .l144 {\n      right: 71%;\n      top: 87%;\n    }\n\n    .l145 {\n      right: 71%;\n      top: 87%;\n    }\n\n    .l146 {\n      right: 34.5%;\n      top: 78.8%;\n    }\n\n    .l147 {\n      right: 6.5%;\n      top: 78.8%;\n    }\n\n    .l148 {\n      right: 34.5%;\n      top: 87%;\n    }\n\n    .l149 {\n      right: 22.7%;\n      top: 87%;\n    }\n\n    .l150 {\n      right: 6.5%;\n      top: 87%;\n    }\n\n    .c1 {\n      right: 30px;\n      bottom: 50px;\n    }\n\n    .c2 {\n      left: 30px;\n      bottom: 50px;\n    }\n\n    .c3 {\n      left: 50%;\n      transform: translateX(-50%);\n      top: 20%;\n    }\n\n    .c4 {\n      right: 15%;\n      top: 38%;\n    }\n\n    .c5 {\n      left: 50%;\n      transform: translateX(-50%);\n      top: 30%;\n    }\n\n    .c6 {\n      left: 50%;\n      transform: translateX(-50%);\n      bottom: 30px;\n    }\n\n    .pie-chart {\n      width: 200px;\n      height: 200px;\n      border-radius: 50%;\n      background: conic-gradient(#2e9db8 0% 25%,\n          #dc1c28 25% 60%,\n          #e9601a 60% 100%);\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .segment {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      margin-bottom: 10px;\n    }\n\n    .percentage {\n      font-size: 24px;\n      font-weight: bold;\n      color: #fff;\n    }\n\n    .label {\n      font-size: 16px;\n      color: #333;\n    }\n  }\n}\n\n.card .table td {\n  font-size: 13px;\n  padding: 5px 10px;\n}\n\ntable.personlDetails-table {\n  border: 1px solid #1d52ff;\n  width: 100%;\n\n  th {\n    background-color: #1d52ff;\n    padding: 6px 10px;\n    color: #ffffff;\n  }\n\n  td {\n    padding: 6px 10px;\n    font-size: 13px;\n    border: 1px dotted #ccc;\n  }\n}\n\n.update-btn {\n  .spinner-border {\n    width: 1rem;\n    height: 1rem;\n  }\n}\n\n.ant-pagination-next,\n.ant-pagination-prev {\n  .anticon {\n    color: #003bfe;\n  }\n}\n\n.status-btn {\n  width: 103px;\n}\n\n.jsontoxlsx {\n  .ant-modal-content {\n    background-color: #fff;\n  }\n\n  .ant-modal-title {\n    background-color: #fff;\n  }\n}\n\n#upload-student-list {\n  display: none;\n}\n\n.upload-student-list-label {\n  border: 1px dashed #cccccc;\n  padding: 20px;\n  background-color: #f7fdff;\n  border-radius: 8px;\n  display: block;\n\n  p {\n    margin-bottom: 0px;\n    text-align: center;\n    font-weight: 400;\n  }\n}\n\n.login-wrapper {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.login-card {\n  display: flex;\n  background: #fff;\n  border-radius: 20px;\n  overflow: hidden;\n  width: 900px;\n  max-width: 95%;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n.login-left {\n  flex: 1;\n  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);\n  color: #fff;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.custom-input {\n  border-radius: 50px;\n  padding-right: 2.5rem;\n}\n\n.custom-input:focus {\n  box-shadow: none;\n}\n\n.form-group .fa-eye,\n.form-group .fa-eye-slash {\n  transition: color 0.2s ease;\n}\n\n.form-group .fa-eye:hover,\n.form-group .fa-eye-slash:hover {\n  color: #0d6efd;\n  /* Bootstrap primary blue on hover */\n}\n\n.login-illustration {\n  width: 80%;\n  max-width: 300px;\n  margin-bottom: 20px;\n}\n\n.login-info-text {\n  text-align: center;\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.login-right {\n  flex: 1;\n  padding: 50px;\n  background: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.welcome-badge {\n  display: inline-block;\n  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);\n  color: #fff;\n  border-radius: 0 20px 20px 0;\n  /* no rounding on left, rounded on right */\n  padding: 6px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  position: absolute;\n  /* or relative depending on your layout */\n  top: -20px;\n  /* adjust as needed */\n  left: -80px;\n  /* aligns to left side */\n}\n\n.custom-input {\n  border: none;\n  border-bottom: 2px solid #ccc !important;\n  border-radius: 0;\n  padding: 10px 5px;\n  box-shadow: none;\n  transition: all 0.3s ease;\n}\n\n.custom-input:focus {\n  border-bottom: 2px solid #6a11cb;\n  box-shadow: none;\n  background-color: #fff !important;\n}\n\n.eye-icon {\n  cursor: pointer;\n  border-bottom: 2px solid #ccc !important;\n}\n\n.login-btn {\n  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%) !important;\n  border: none;\n  font-weight: 500;\n}\n\n.login-btn:hover {\n  opacity: 0.9;\n}\n\n@media (max-width: 768px) {\n  .login-card {\n    flex-direction: column;\n  }\n\n  .login-left,\n  .login-right {\n    width: 100%;\n    padding: 30px;\n  }\n\n  .login-illustration {\n    max-width: 200px;\n  }\n}\n\n@media (max-width: 768px) {\n  .login-card {\n    flex-direction: column;\n  }\n\n  .login-left,\n  .login-right {\n    width: 100%;\n    padding: 30px;\n  }\n\n  .login-illustration {\n    max-width: 200px;\n  }\n}\n\n/* ✅ Responsive header layout */\n@media (max-width: 768px) {\n  .card-header.d-flex {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n  }\n\n  .card-header .d-flex.align-items-center {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n  }\n\n  .xlsxDownloadBtn {\n    width: 100%;\n    padding: 10px;\n    margin-bottom: 10px;\n    background-color: #0d6efd !important;\n  }\n\n  .search-container {\n    display: flex;\n    width: 100%;\n  }\n\n  .search-container input {\n    flex: 1;\n  }\n\n  .search-container .search_btn {\n    margin-left: 5px;\n    width: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n/* ✅ Card layout for small screens */\n@media (max-width: 768px) {\n  .mobile-card-grid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n}\n\n/* ✅ Tablet view - 2 cards per row */\n@media (min-width: 769px) and (max-width: 1024px) {\n  .mobile-card-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1rem;\n  }\n}\n\n// .navbar-vertical .navbar-nav .nav-link:hover  {\n//   color: blue !important;\n// }\n\n.navLink.active {\n  background-color: rgba(255,255,255,0.15);\n  border-radius: 8px;\n}\n\n.navLink {\n  padding: 12px 15px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  text-decoration: none !important;\n  font-size: 15px;\n}\n\n.navLink.active {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  font-weight: 600;\n}\n\n.ant-message {\n  right: auto !important;\n  left: 525px !important;\n  top: 20px !important;\n  transform: none !important;\n}\n\n.select-box {\n  select {\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    padding: 5px 10px;\n    font-size: 14px;\n    outline: none;\n    background-color: #0d6efd;\n    color: #fff;\n    border: none;\n    margin-right: 1300px;\n    display: inline-flex;\n    align-items: center;\n  }\n}\n.option-layout{\n  background-color: #fff !important;\n  color: #000 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
